// Player visibility helpers
// Fuente de verdad: player_club_memberships.status (por club)
// Backward compat: jugadores.estatus (sincronizado via trigger)

const normalizeValue = (value) => (value || '').toString().trim().toLowerCase();

export const normalizePlayerStatus = (status) => normalizeValue(status);

// Mapeo de estatus español → ingles y viceversa
export const STATUS_MAP_ES_EN = {
  activo: 'active',
  pendiente: 'pending',
  suspendido: 'suspended',
  inactivo: 'inactive',
  baja: 'retired',
}

export const STATUS_MAP_EN_ES = {
  active: 'Activo',
  pending: 'Pendiente',
  suspended: 'Suspendido',
  inactive: 'Inactivo',
  retired: 'Baja',
  transferred: 'Baja',
}

export const STATUS_LABELS = {
  active: 'Activo',
  pending: 'Pendiente',
  suspended: 'Suspendido',
  inactive: 'Inactivo',
  retired: 'Baja',
  transferred: 'Transferido',
  // Legacy español
  Activo: 'Activo',
  Pendiente: 'Pendiente',
  Suspendido: 'Suspendido',
  Inactivo: 'Inactivo',
  Baja: 'Baja',
}

export const isPlayerBajaStatus = (status) => {
  const n = normalizeValue(status);
  return n === 'baja' || n === 'retired' || n === 'transferred';
};

export const isPlayerDeleted = (player) => {
  if (!player) return true;
  if (player.deleted === true) return true;
  if (player.activo === false) return true;
  return false;
};

export const isPlayerActiveFlag = (player) => {
  if (!player) return false;
  if (player.activo === false) return false;
  return true;
};

// Un jugador es visible si NO esta dado de baja
export const isVisiblePlayer = (player) => {
  if (!player) return false;
  if (isPlayerDeleted(player)) return false;
  if (isPlayerBajaStatus(player.estatus)) return false;
  return true;
};

export const isActiveGroupRelation = (relation) => {
  if (!relation) return false;
  if (relation.deleted === true || relation.deleted_at) return false;
  if (relation.activo === false) return false;
  const status = normalizeValue(relation.estatus);
  if (status === 'baja' || status === 'inactivo' || status === 'inactiva') return false;
  return true;
};

export const isVisibleGroupRelation = (relationStatus) => {
  if (!relationStatus) return true;
  const status = normalizeValue(relationStatus);
  if (status === 'baja' || status === 'inactivo' || status === 'inactiva') return false;
  return true;
};
